import { useMutation } from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_FILE_STORAGE } from "../domain";

import { fileApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_DOWNLOAD_FILE_PREVIEW = "DOWNLOAD_FILE_PREVIEW";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent, UserRole.Viewer, UserRole.Auditor];

interface DownloadFileRequest {
  path: string;
  name: string;
}

const downloadFilePreview = async ({
  path,
  name,
}: DownloadFileRequest): Promise<File> => {
  const response = await fileApi.fileStorageControllerDownloadFile(path, {
    responseType: "blob",
  });

  return new File([response.data], name);
};

export const useDownloadFilePreview = (
  user: UserProfileDto | null,
): {
  downloadFilePreview: ({ path, name }: DownloadFileRequest) => Promise<File>;
  downloadFileEnabled: boolean;
  isSuccessDownloadFile: boolean;
  isPendingDownloadFile: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FILE_STORAGE, ACTION_DOWNLOAD_FILE_PREVIEW],
    mutationFn: downloadFilePreview,
  });

  return {
    downloadFilePreview: mutateAsync,
    downloadFileEnabled: enabled,
    isSuccessDownloadFile: isSuccess,
    isPendingDownloadFile: isPending,
  };
};
